<div class="space-y-md" *transloco="let t">
  <h3 class="heading-lg">
    {{ t('proDirectoryPage.sideNav.directLinks.title') }}
  </h3>
  <ul class="space-y-xs">
    <li>
      <a [routerLink]="searchLink" class="btn btn-link">
        {{ t('proDirectoryPage.sideNav.directLinks.startSearch') }}
      </a>
    </li>
    <li>
      <a [routerLink]="otherJobRequestLink" class="btn btn-link">
        {{ t('proDirectoryPage.sideNav.directLinks.startRequest') }}
      </a>
    </li>
    <li>
      <a [routerLink]="magazineLink" class="btn btn-link">
        {{ t('proDirectoryPage.sideNav.directLinks.magazine') }}
      </a>
    </li>
  </ul>
</div>
